import MainLayout from "./MainLayout";
import Aboutus from "../assets/images/Aboutus.png";

const AboutUs = () => {
  return (
    <MainLayout>
      {/* Top Banner */}
      <section className="w-full bg-black text-white py-20">
        <h1 className="text-center text-5xl md:text-7xl font-extrabold text-gray-200 leading-tight pt-2">
          About Us
        </h1>
        <p className="text-xl text-gray-400 text-center mt-4">
          We are on a mission to democratize AI-powered data analysis.
        </p>
      </section>

      {/* Content Section */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          
          {/* Left Image */}
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <img
              src={Aboutus}
              alt="About XynexAI"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          {/* Right Content */}
          <div className="space-y-6 text-left">
            <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-500 to-pink-500 bg-clip-text text-transparent">
              Using Technology to Avert Threat
            </h2>

            <p className="text-gray-200 leading-relaxed">
              We are a team of seasoned professionals united by a common
              purpose: leveraging innovative technology solutions to drive
              business transformation while contributing positively to
              society.
            </p>

            <p className="text-gray-200 leading-relaxed">
              Our approach combines deep industry knowledge with cutting-edge
              technological capabilities to solve complex business challenges
              globally by providing sector-agnostic solutions to strengthen
              Risk Assurance, Enterprise Risk Management and improve bottom
              line.
            </p>

            <p className="text-gray-200 leading-relaxed">
              We enable identification of control gaps, early detection of
              fraudulent transactions, revenue leakages or cost saving
              opportunities using big data analytics and AI/ML technology.
            </p>
          </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default AboutUs;
